import {Component, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {
  SaveRevertButtonsComponent,
  SaveRevertButtonsStatus,
} from '../../../../components/save-revert-buttons/save-revert-buttons.component';
import {HubsService} from '../../../../../core/services/hubs.service';
import {ShadeToolsService} from '../../../../../core/services/shade-tools.service';
import {HubId} from '../../../../../shared/models/hub';
import {Router} from '@angular/router';
import {UrlService} from '../../../../../core/services/url.service';
import {SubtitleItem} from '../../../../../core/state/title.state';
import {TitleChangedAction} from '../../../../../core/actions/title.actions';
import {Store} from '@ngrx/store';
import {AppState} from '../../../../../app/app.state';
import {FormsModule} from '@angular/forms';
import {DialogBoxButtonColor} from '../../../../../shared/models/dialog-box';

// validation for an input of activation code of the hub. Used on the backend, here just for the info
// TODO: later add validation on the input, and give info on why user cant use some chars
const ACTIVATION_CODE_CHARACTERS = 'ACDEFHJKLMNPQRTUWXY2346789';

@Component({
  selector: 'motn-hubs-new',
  templateUrl: './hubs-new.component.html',
  styleUrls: ['./hubs-new.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    SaveRevertButtonsComponent,
  ],
})
export class HubsNewComponent implements OnInit {
  hubId: string = '';
  activationCode: string = '';

  status: SaveRevertButtonsStatus;

  @ViewChild('saveButton') saveButton: SaveRevertButtonsComponent;


  constructor(
    private hubsService: HubsService,
    private shadeTools: ShadeToolsService,
    private router: Router,
    private store: Store<AppState>,
  ) {
  }


  ngOnInit(): void {
    this.updateTitle();
  }


  protected updateTitle() {
    const subtitle: SubtitleItem[] = [{
      text: 'Ready to activate',
    }];

    this.store.dispatch(new TitleChangedAction(
      '',
      'Hubs',
      subtitle,
    ));
  }


  onHubIdChange() {
    const hubId = this.hubId;

    setTimeout(() => this.hubId = hubId.replace(/\D/, ''), 0);

    this.updateStatus();
  }


  onActivationCodeChange() {
    const ac: string = this.activationCode.toUpperCase();
    const aca: string[] = ac.split('');

    if (aca.length > 4) {
      if (aca[4] !== '-') {
        const aca4 = aca[4];

        aca[4] = '-';
        aca[5] = aca4;
      }
    }

    if (aca.length > 9) {
      if (aca[9] !== '-') {
        const aca9 = aca[9];
        aca[9] = '-';
        aca[10] = aca9;
      }
    }

    this.updateStatus();

    setTimeout(() => this.activationCode = aca.join(''), 0);
  }


  updateStatus() {
    if (this.hubId.length >= 5 && this.activationCode.length === 14) {
      this.status = 'edited';
    } else {
      this.status = '';
    }
  }


  activate() {
    const hubId: HubId = this.hubId;

    this.hubsService.activateHub$(hubId, this.activationCode).subscribe(
      (hub) => {
        this.shadeTools.startDialog(
          'Activation Successful',
          `The Motion Hub was added to your account.`,
          [
            {
              text: 'Add Another',
              color: DialogBoxButtonColor.Green,
              callback: () => {
              },
            },
            {
              text: 'Go to My Hubs',
              color: DialogBoxButtonColor.Default,
              callback: () => {
                this.router.navigate([UrlService.controlsUrls.hubsExisting]);
              },
            },
          ],
        );

        this.activationCode = '';
        this.hubId = '';
        this.saveButton.showSavedStatus();
      },
      (err) => {
        this.status = 'edited';

        if (err?.status === 409) {
          this.shadeTools.errorDialog('This activation code has already been used.');
        } else {
          this.shadeTools.errorDialog('The information you entered could not be validated. Please check the values for accuracy and try again.');
        }
      },
    );
  }
}
